import {
  type IPackageCardProps,
  PackageCard,
} from 'pages/settings/pages/compliance/pages/localNumbers/pages/Package/ui/PackageCard/PackageCard.tsx'
import { packageTooltipDesc } from './data.tsx'

export const LVSPackageCard = (props: Partial<IPackageCardProps>) => {
  return (
    <PackageCard
      title={'Low volume standard'}
      infoOne={{
        title: 'up to 2,000 SMS / MMS segments per day',
        tooltip: packageTooltipDesc,
      }}
      infoTwo={{
        title: 'up to 3.75 MPS',
        tooltip: 'Messages per second',
      }}
      {...props}
    />
  )
}
